import { useTranslation, Trans } from 'react-i18next';
import { Trash2 } from 'lucide-react';
import { ConfirmModal } from '@/components/ui/ConfirmModal';

interface DeleteRunnerModalProps {
    runnerName?: string | null;
    isDeleting: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function DeleteRunnerModal({ runnerName, isDeleting, onConfirm, onCancel }: DeleteRunnerModalProps) {
    const { t } = useTranslation('races');
    const { t: tc } = useTranslation();

    return (
        <ConfirmModal
            icon={<Trash2 size={24} />}
            iconClassName="bg-red-50 text-red-500"
            title={t('details.deleteRunner.title')}
            message={
                <Trans
                    i18nKey="races:details.deleteRunner.message"
                    values={{ name: runnerName }}
                    components={{ strong: <span className="font-bold text-slate-800" /> }}
                />
            }
            confirmLabel={tc('btn.delete')}
            confirmClassName="bg-red-500 hover:bg-red-600 shadow-red-200"
            isLoading={isDeleting}
            onConfirm={onConfirm}
            onCancel={onCancel}
        />
    );
}
